import { History as HistoryIcon, Clock, FileText } from 'lucide-react';
import Card from '@components/common/Card';

const History = () => {
  return (
    <div className="w-full max-w-6xl mx-auto">
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
          <HistoryIcon className="w-8 h-8 text-primary-600" />
          <h1 className="text-3xl font-bold text-gray-900">Activity History</h1>
        </div>
        <p className="text-gray-600">View your recent activities and transactions</p>
      </div>

      <Card>
        <div className="flex items-center justify-center py-16">
          <div className="text-center">
            <Clock className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-gray-700 mb-2">No history yet</h3>
            <p className="text-gray-500">Your activity history will appear here</p>
          </div>
        </div>
      </Card>

      {/* Timeline placeholder */}
      <div className="mt-6">
        <h2 className="text-lg font-bold text-gray-900 mb-4">Recent Activities</h2>
        <div className="space-y-4">
          {[1, 2, 3].map((item) => (
            <Card key={item}>
              <div className="flex items-start gap-4 opacity-30">
                <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center flex-shrink-0">
                  <FileText className="w-5 h-5 text-gray-400" />
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold text-gray-700">Activity placeholder</h3>
                  <p className="text-sm text-gray-500">No activities to display</p>
                  <p className="text-xs text-gray-400 mt-1">Just now</p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default History;
